export default {
    methods: {
        svgIconPath(iconName) {
            console.log({ iconName });
            // iconName is expected in the form of 'seating-theatre.svg', 'seating-banquet.svg', etc.
            // Handle both relative and absolute paths
            if (iconName?.startsWith('/') || iconName?.startsWith('http')) {
                return iconName;
            }
            return require(`@/assets/img/seating-style/${iconName}`);
        },
    }
}